<div class="w-full relative">
  <!-- Textarea: same component, structure, and classes as State/other inputs – same style, binding, behavior -->
  <div *ngIf="displayType === 'textarea'" class="relative">
    <textarea
      #textareaElement
      [id]="displayId"
      [name]="displayName"
      [placeholder]="computedPlaceholder"
      [required]="isRequired"
      [disabled]="isDisabled"
      [readonly]="isReadonly"
      [attr.maxlength]="config?.maxLength ?? maxLength"
      [attr.minlength]="config?.minLength ?? minLength"
      [rows]="displayRows || 3"
      (input)="onInputChange($event)"
      (focus)="onFocus($event)"
      (blur)="onInputBlur($event)"
      [ngStyle]="displayInputStyle"
      [class.border-red-500]="hasError"
      [class.bg-bg]="!hasCustomInputBackground"
      class="input-textarea w-full px-3 py-2.5 text-[14px] border border-primary rounded-md text-primary focus:outline-none transition-colors disabled:bg-surface disabled:cursor-not-allowed disabled:opacity-60 font-semibold min-h-[40px] resize-y">
    </textarea>
    <label *ngIf="displayLabel" [for]="displayId" [class.floating-label-active]="isFocused || hasValue"
      [class.text-red-500]="isLabelEmphasized" [class.text-muted]="!isLabelEmphasized"
      [ngStyle]="displayLabelStyle"
      class="floating-label absolute left-3 text-[13px] font-medium pointer-events-none transition-all duration-200">
      {{ displayLabel }}
      <span *ngIf="isLabelEmphasized" class="text-red-500 ml-1">*</span>
    </label>
  </div>

  <!-- Time Picker -->
  <div *ngIf="displayType === 'time'" class="relative">
    <app-time-picker [id]="displayId" [name]="displayName" [label]="displayLabel" [value]="$any(currentValue)"
      [placeholder]="displayPlaceholder" [required]="isRequired" [disabled]="isDisabled" [readonly]="isReadonly"
      (valueChange)="onCustomChange($event)" (blur)="onInputBlur($event)">
    </app-time-picker>
  </div>

  <!-- Regular input for all other types -->
  <div *ngIf="displayType !== 'textarea' && displayType !== 'time'" class="relative">
    <input #inputElement [type]="displayType" [id]="displayId" [name]="displayName"
      [placeholder]="computedPlaceholder" [attr.pattern]="displayPattern || null"
      [required]="isRequired" [disabled]="isDisabled" [readonly]="isReadonly" [attr.min]="(config?.min ?? min) || null"
      [attr.max]="(config?.max ?? max) || null" [attr.step]="(config?.step ?? step) || null"
      [attr.maxlength]="(config?.maxLength ?? maxLength) || null"
      [attr.minlength]="(config?.minLength ?? minLength) || null"
      [attr.autocomplete]="(config?.autocomplete ?? autocomplete) || null" (input)="onInputChange($event)"
      (keydown)="onKeyDown($event)" (keyup)="onKeyUp($event)" (paste)="onPaste($event)" (blur)="onInputBlur($event)"
      (focus)="onFocus($event)" [ngStyle]="displayInputStyle" [class.border-red-500]="hasError" [class.pr-10]="icon"
      [class.bg-bg]="!hasCustomInputBackground"
      class="w-full px-3 py-2.5 text-[14px] border border-primary rounded-md text-primary focus:outline-none transition-colors disabled:bg-surface disabled:cursor-not-allowed disabled:opacity-60 font-semibold h-[40px]" />

    <!-- Icon -->
    <i *ngIf="icon" [class]="icon + ' absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer ' + iconColor"
      [attr.title]="iconTitle || null"
      (click)="onIconClick()"></i>

    <label *ngIf="displayLabel" [for]="displayId" [class.floating-label-active]="isFocused || hasValue"
      [class.text-red-500]="isLabelEmphasized" [class.text-muted]="!isLabelEmphasized"
      [ngStyle]="displayLabelStyle"
      class="floating-label absolute left-3 text-[13px] font-medium pointer-events-none transition-all duration-200">
      {{ displayLabel }}
      <span *ngIf="isLabelEmphasized" class="text-red-500 ml-1">*</span>
    </label>
  </div>
  <!-- Error messages should be handled by app-form-error-message component in the parent template -->
</div>